interface WorldAndSchemeLineSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WorldAndSchemeLineSVG = ({
  color,
  style,
}: WorldAndSchemeLineSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="67"
    height="50"
    viewBox="0 0 67 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_13650)">
      <path
        d="M3.10718 23.4955H28.5186"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8069 10.7223V23.5078"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8193 36.0354V23.4955"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.687744 23.5078C0.687744 15.1561 7.45512 8.36414 15.8069 8.36414C24.1586 8.36414 30.9383 15.1806 30.9383 23.5324V23.5078C30.9383 31.8596 24.1709 38.6393 15.8069 38.6393C7.44284 38.6393 0.687744 31.8719 0.687744 23.5078Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6309 11.8646C9.64124 14.1736 7.70068 17.9196 7.70068 23.7536"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9211 11.7909C21.9231 14.0876 23.9128 17.8582 23.9128 23.7536"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6829 34.7705C22.4023 32.4246 23.9253 28.8997 23.9253 23.7535"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8449 34.6354C9.16224 32.2896 7.70068 28.8015 7.70068 23.7659"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8068 17.0106C11.0168 17.0106 8.25338 15.5613 6.77954 14.3331"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8339 14.3331C23.3601 15.5613 20.5966 16.9983 15.8066 16.9983"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8338 32.6702C23.36 31.442 20.5965 30.005 15.8188 30.005"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.68115 32.7562C8.13043 31.5034 10.9062 30.005 15.8067 30.005"
        stroke={color}
        strokeWidth="1.37558"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.7192 38.5901V43.6257"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.3022 29.5875H64.1364C65.0453 29.5875 65.7699 30.3244 65.7699 31.221V36.9567C65.7699 37.8656 65.033 38.5902 64.1364 38.5902H39.3022C38.3933 38.5902 37.6687 37.8533 37.6687 36.9567V31.221C37.6687 30.3122 38.4056 29.5875 39.3022 29.5875Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M51.7192 34.0828H59.5429"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M62.7607 34.0828C62.7607 33.9108 62.6133 33.7634 62.4414 33.7634C62.2695 33.7634 62.1221 33.9108 62.1221 34.0828C62.1221 34.2547 62.2695 34.4021 62.4414 34.4021C62.6133 34.4021 62.7607 34.2547 62.7607 34.0828Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.3022 15.1316H64.1364C65.0453 15.1316 65.7699 15.8685 65.7699 16.7651V22.5008C65.7699 23.4097 65.033 24.1343 64.1364 24.1343H39.3022C38.3933 24.1343 37.6687 23.3974 37.6687 22.5008V16.7651C37.6687 15.8562 38.4056 15.1316 39.3022 15.1316Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M51.7192 19.639H59.5429"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M62.7607 19.639C62.7607 19.4671 62.6133 19.3197 62.4414 19.3197C62.2695 19.3197 62.1221 19.4671 62.1221 19.639C62.1221 19.811 62.2695 19.9584 62.4414 19.9584C62.6133 19.9584 62.7607 19.811 62.7607 19.639Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.3022 0.687866H64.1364C65.0453 0.687866 65.7699 1.42479 65.7699 2.32137V8.05706C65.7699 8.96593 65.033 9.69057 64.1364 9.69057H39.3022C38.3933 9.69057 37.6687 8.95365 37.6687 8.05706V2.32137C37.6687 1.4125 38.4056 0.687866 39.3022 0.687866Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M51.7192 5.19543H59.5429"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M62.7607 5.19543C62.7607 5.02348 62.6133 4.8761 62.4414 4.8761C62.2695 4.8761 62.1221 5.02348 62.1221 5.19543C62.1221 5.36738 62.2695 5.51476 62.4414 5.51476C62.6133 5.51476 62.7607 5.36738 62.7607 5.19543Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.8066 38.5901V43.6257"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M51.7192 29.5874V24.1465"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M51.7192 15.1315V9.70288"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.6558 43.6257H12.9692V49.3123H18.6558V43.6257Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M54.5689 43.6257H48.8823V49.3123H54.5689V43.6257Z"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.8822 46.4752H18.6562"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M54.5564 46.4752H65.7821"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.9696 46.4752H1.7561"
        stroke={color}
        strokeWidth="1.37558"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_13650">
        <rect width="66.4579" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default WorldAndSchemeLineSVG;
